import { api } from "@/api"
import type { MerchantGroupUser } from "./types"
export type RetrieveMerchantGroupUserResponse =
  MerchantGroupUser

export const retrieveMerchantGroupUser = async (
  userId: MerchantGroupUser["id"]
) => {
  const { body } =
    await api.get<RetrieveMerchantGroupUserResponse>(
      `/merchant-group/users/${userId}/`,
      { isMerchantGroup: true }
    )

  return body
}
